import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { getDagDashboardDetailMock } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { DagDashboardDetailRequest, DagDashboardResponse } from '@/entities/dag/domain/types';

export const fetchDagDashboardDetailApi = async ({
  dagUuid,
}: DagDashboardDetailRequest): Promise<DagDashboardResponse> => {
  if (shouldUseDagMockApi()) {
    return getDagDashboardDetailMock({ dagUuid });
  }

  const response = await cycloneApiClient.get<DagDashboardResponse>(`/dags/${dagUuid}`);
  return response.data;
};
